import { axiosInstance } from '../clients/axiosClient';
import { QUESTIONS_API_PREFIX, API_V1_PREFIX } from '../utils/constants';
import {
  MedicalAnswerRequest,
  MedicalAnswerResponse,
  MedicalQuestionsResponse,
} from '../types/apiGeneratedTypes';

export const getMedicalQuestionsList = async (
  member_id: string
): Promise<MedicalQuestionsResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${QUESTIONS_API_PREFIX}list/${member_id}`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const answerMedicalQuestion = async (
  requestObj: MedicalAnswerRequest
): Promise<MedicalAnswerResponse> => {
  try {
    const { data } = await axiosInstance.post(
      `${API_V1_PREFIX}${QUESTIONS_API_PREFIX}answer`,
      requestObj
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};
